import { useEffect, useState } from "react";
import confetti from "canvas-confetti";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ThankYouPage() {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(600); // 600 segundos = 10 minutos

  // Lanzar confeti al cargar
  useEffect(() => {
    confetti({
      particleCount: 150,
      spread: 70,
      origin: { y: 0.6 },
    });
  }, []);

  // Contador regresivo
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Formatear el tiempo mm:ss
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-center px-4">
      <CheckCircle2 className="w-20 h-20 text-green-500 mb-4" />
      <h1 className="text-3xl font-bold mb-2">¡Gracias por tu solicitud!</h1>
      <p className="text-muted-foreground mb-4 max-w-md">
        En breves minutos validaremos tu pago y activaremos tu suscripción.
      </p>

      <div className="text-sm mb-6 text-muted-foreground">
        Tiempo estimado de validación:{" "}
        <span className="font-semibold text-foreground">
          {formatTime(timeLeft)}
        </span>
      </div>

      <Button onClick={() => navigate("/dashboard")}>Volver al inicio</Button>
    </div>
  );
}
